import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import {
  AlertDialogComponent,
  ConfirmDialogComponent,
  ConfirmDialogData,
  ErrorDialogComponent,
  ErrorHttpDialogComponent,
  SuccessDialogComponent,
} from '../../lib/notification';
import { AlertDialogData } from '../../types';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  modalRef?: BsModalRef;

  constructor(private modalService: BsModalService) {}

  alert(message: string, title = ''): void {
    this.modalService.show(AlertDialogComponent, {
      class: 'modal-sm',
      initialState: {
        data: { message, title } as AlertDialogData,
      },
    });
  }

  confirm(data: ConfirmDialogData): Promise<boolean> {
    const modalRef = this.modalService.show(
      ConfirmDialogComponent,
      {
        class: 'modal-sm',
        initialState: { data },
      }
    );

    return new Promise<boolean>((resolve) => {
      this.modalRef = modalRef;

      modalRef.onHidden?.subscribe(() => {
        const result = modalRef.content?.result;
        resolve(result === true);
      });
    });
  }

  success(data: AlertDialogData): void {
    this.modalService.show(SuccessDialogComponent, {
      class: 'modal-sm',
      initialState: { data: data },
    });
  }

  error(message: string, title = ''): void {
    this.modalService.show(ErrorDialogComponent, {
      class: 'modal-sm',
      initialState: {
        data: { message, title } as AlertDialogData,
      },
    });
  }

  httpError(error: HttpErrorResponse): Promise<undefined> {
    const modalRef: BsModalRef<ErrorHttpDialogComponent> =
      this.modalService.show(ErrorHttpDialogComponent, {
        class: 'modal-md',
        initialState: { statusCode: error.status },
      });

    return new Promise<undefined>((resolve) => {
      modalRef.onHidden?.subscribe(() => {
        resolve(undefined);
      });
    });
  }
}
